export enum TestLabFormControls {
  AGENT_ID = "agentId",
  BROWSER = "browser",
  CAPABILITIES = "capabilities",
  CREATE_SESSION_AT_CASE_LEVEL = "createSessionAtCaseLevel",
  DEVICE_ID = "deviceId",
  DEVICE_NAME = "deviceName",
  ID = "id",
  OS_VERSION = "osVersion",
  PLATFORM = "platform",
  PLATFORM_BROWSER_VERSION_ID="platformBrowserVersionId",
  PLATFORM_DEVICE_ID="platformDeviceId",
  PLATFORM_OS_VERSION_ID = "platformOsVersionId",
  PLATFORM_SCREEN_RESOLUTION_ID = "platformScreenResolutionId",
  PREREQUISITE_TEST_DEVICES_ID = "prerequisiteTestDevicesId",
  PREREQUISITE_TEST_DEVICES_ID_INDEX = "prerequisiteTestDevicesIdIndex",
  RESOLUTION = "resolution",
  SUITE_IDS = "suiteIds",
  TESTPLAN_LABTYPE = "testPlanLabType",
  TITLE = "title",
  WORKSPACE_VERSION_ID = "workspaceVersionId",
}
